module.exports = __webpack_public_path__ + "img/团队协作.c91f7e58.png";